module.exports = __webpack_public_path__ + "img/Footer_Session.e55b1771.png";